import { UserRole } from '../../application/entities/authenticated-user.entity';
import { AuthSession } from '../../application/entities/auth-session.entity';
import { LoginCredentials } from '../../application/entities/login-credentials.entity';
import { LoginRequestDto } from '../dto/login-request.dto';
import { LoginResponseDto } from '../dto/login-response.dto';

export const toLoginRequestDto = (
  credentials: LoginCredentials,
): LoginRequestDto => ({
  email: credentials.email.trim().toLowerCase(),
  password: credentials.password,
  rememberMe: credentials.rememberMe,
});

export const toAuthSessionEntity = (dto: LoginResponseDto): AuthSession => {
  const data = dto.data!;
  return {
    accessToken: data.accessToken,
    tokenType: data.tokenType,
    expiresIn: data.expiresIn,
    permissions: data.role?.permissions ?? [],
    orgType: data.orgType,
    user: {
      uuid: data.user.uuid,
      email: data.user.email,
      fullName: `${data.user.firstName} ${data.user.lastName}`.trim(),
      firstName: data.user.firstName,
      lastName: data.user.lastName,
      phone: data.user.phone,
      role: (data.role.name as UserRole) ?? 'admin',
      clientFilter: undefined,
      avatarUrl: data.user.avatarUrl ?? 'assets/Avatar.png',
      organization: {
        uuid: data.organization.uuid,
        name: data.organization.name,
        contractNumber: data.organization.listingNumber,
        logoUrl: 'assets/Logo_Original.png',
      },
    },
  };
};
